import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  getE4collEstablishments,
  getE4collMercurials,
  getE4collInterventions,
  getE4collMaintenances,
  getE4collDm,
} from "../../../actions/stats/stats";

class StatsE4coll extends React.Component {
  render() {
    const links = [
      {
        fileName: "e4coll_etablissements_par_clients",
        onExport: this.props.onGetE4collEstablishments,
        formattedMessage: "Nb.Establishments.By.Psdm",
      },
      {
        fileName: "e4coll_mercuriales_par_clients",
        onExport: this.props.onGetE4collMercurials,
        formattedMessage: "Nb.Mercurials.By.Psdm",
      },
      {
        fileName: "e4coll_interventions_par_clients",
        onExport: this.props.onGetE4collInterventions,
        formattedMessage: "Nb.Interventions.By.Establishment",
      },
      {
        fileName: "e4coll_maintenances_par_clients",
        onExport: this.props.onGetE4collMaintenances,
        formattedMessage: "Nb.Maintenances.By.Establishment",
      },
      {
        fileName: "e4coll_dm_par_clients",
        onExport: this.props.onGetE4collDm,
        formattedMessage: "Nb.Dm.By.Establishment",
      },
    ];

    const linksNode = links.map((link, index) => {
      return (
        <li key={index}>
          <button
            className="btn btn-link"
            onClick={() =>
              this.props.openConfModal(link.fileName, (successCallback) =>
                link.onExport(successCallback),
              )
            }
          >
            <FormattedMessage id={link.formattedMessage} />
          </button>
        </li>
      );
    });

    return (
      <div>
        <ul style={{ listStyleType: "none" }}>{linksNode}</ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetE4collEstablishments: (successCallback) =>
      dispatch(getE4collEstablishments(successCallback)),
    onGetE4collMercurials: (successCallback) =>
      dispatch(getE4collMercurials(successCallback)),
    onGetE4collInterventions: (successCallback) =>
      dispatch(getE4collInterventions(successCallback)),
    onGetE4collMaintenances: (successCallback) =>
      dispatch(getE4collMaintenances(successCallback)),
    onGetE4collDm: (successCallback) => dispatch(getE4collDm(successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatsE4coll));
